import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from './AppUserProfile';
import { Subject } from 'rxjs';
import { Headers, Http, RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

@Injectable()
export class NavigationService {
  // Observable that components can subscribe to for navigation events
  private pageChangeSubject = new Subject<string>();
  public pageChange$ = this.pageChangeSubject.asObservable();

  // Track current page
  private currentUrl: string = '';

  // Base URL for API calls
  private baseUrl: string = environment.base_url;

  constructor(
    private router: Router,
    private http: Http,
    private cookieService?: CookieService,
    private appUser?: AppWideUser,
    private token?: Token
  ) {
    // Subscribe to router events
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // This code will run on every page navigation
      this.currentUrl = event.url;
      console.log('Navigation to:', this.currentUrl);

      // Process the navigation event
      this.onPageChange(this.currentUrl);

      // Notify subscribers about the page change
      this.pageChangeSubject.next(this.currentUrl);
    });
  }

  // This method runs on every page navigation
  private onPageChange(url: string) {
    console.log('Page changed to:', url);

    // Check authentication if needed
    this.checkAuthentication();

    // Call the test API on every page navigation
    this.callTestApi();
  }

    // Test API call that will run on every page navigation
  private callTestApi() {
    console.log('Calling test API on route change to:', this.currentUrl);

    // Get token from cookie if available
    if (this.cookieService && this.token && this.cookieService.check('Token')) {
      try {
        const tokenData = JSON.parse(this.cookieService.get('Token'));

        // Make the API call with token
        this.testApiCall(tokenData).subscribe(
          (data) => {
            console.log('API test call successful on route:', this.currentUrl);
            console.log('API response data:', data);
          },
          (error) => {
            console.error(`API test failed on route ${this.currentUrl}:`, error);

            // If authentication failed, try without token as fallback
            console.log('Attempting API test call without authentication...');
            this.testApiCallWithoutAuth().subscribe(
              (data) => {
                console.log('API test call without auth successful on route:', this.currentUrl);
                console.log('API response data:', data);
              },
              (error) => {
                console.error(`API test without auth failed on route ${this.currentUrl}:`, error);
              }
            );
          }
        );
      } catch (err) {
        console.error('Error parsing token data for API test:', err);
        // Try without authentication as fallback
        this.callTestApiWithoutAuth();
      }
    } else {
      console.log('No token available for API test call, trying without authentication');
      this.callTestApiWithoutAuth();
    }
  }

  // Call test API without authentication
  private callTestApiWithoutAuth() {
    this.testApiCallWithoutAuth().subscribe(
      (data) => {
        console.log('API test call without auth successful on route:', this.currentUrl);
        console.log('API response data:', data);
      },
      (error) => {
        console.error(`API test without auth failed on route ${this.currentUrl}:`, error);
      }
    );
  }

    // Actual API call method with authentication
  private testApiCall(token: any) {
    // Call the specific "test" API endpoint
    const url = this.baseUrl + 'api/test';
    const bearer = 'Bearer ' + token.access_token;
    const body = {
      route: this.currentUrl,
      timestamp: new Date().toISOString()
    };

    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': bearer
    });

    const options = new RequestOptions({
      headers: headers,
      method: "post"
    });

    return this.http.post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // API call method without authentication
  private testApiCallWithoutAuth() {
    // Call the specific "test" API endpoint without authentication
    const url = this.baseUrl + 'api/test';
    const body = {
      route: this.currentUrl,
      timestamp: new Date().toISOString()
    };

    const headers = new Headers({
      'Content-Type': 'application/json'
    });

    const options = new RequestOptions({
      headers: headers,
      method: "post"
    });

    return this.http.post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Extract data from response
  private extractData(res: any) {
    const body = res.json();
    return body || {};
  }

  // Handle API errors
  private handleError(error: any) {
    console.error('API error:', error);
    return Promise.reject(error.message || error);
  }

  // Check if user is authenticated
  private checkAuthentication() {
    if (this.cookieService && this.appUser && this.token) {
      if (this.cookieService.check('AppWideUser') && this.cookieService.check('Token')) {
        // User is authenticated
        console.log('User is authenticated');

        // You could refresh user data here if needed
        try {
          const userData = JSON.parse(this.cookieService.get('AppWideUser'));
          const tokenData = JSON.parse(this.cookieService.get('Token'));

          // Do something with the user data if needed
        } catch (err) {
          console.error('Error parsing user data:', err);
        }
      } else {
        // User is not authenticated
        console.log('User is not authenticated');

        // You could redirect to login page if needed
        // this.router.navigate(['/login']);
      }
    }
  }

  // Get current page URL
  getCurrentUrl(): string {
    return this.currentUrl;
  }

  // Navigate to a new page
  navigateTo(url: string): void {
    this.router.navigate([url]);
  }
}




// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Services/navigation.service.ts